<template>
  <div>
    <DesktopLandingPage v-if="!isMobile"/>
    <div class="signin-wrapper" v-if="isMobile">
      <div class="header">{{ $t('landing.name')}}</div>
      <h2>{{ $t('landing.title')}}</h2>
      <img class="image-wrapper" src="@/assets/app-view-min.png" width="200">
      <div class="login-button" onselectstart="return false"
        @click="download" v-if="isMobile">{{ $t('landing.download')}}</div>

    </div>
    <div class="install-baner-wrapper" v-if="isIos() && showIOSBaner">
      <div class="install-baner-wrapper__positioner">
        <div class="install-baner-wrapper__text">
          <img
              class="plus-icon"
              src="@/assets/shere-ios-icon.svg"
              width="25"
              style="margin: 0 13px;"
            />
          <p style="margin: 10px;">
            {{ $t('landing.iosInstallInfo')}}
            <img
              class="plus-icon"
              src="@/assets/plus-square.svg"
              width="30"
              style="margin: 4px 10px;"
            />{{ $t('landing.iosInstallInfo2')}}
          </p>
          </div>
          <div class="install-baner-wrapper__arrow-down"/>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Cookies from 'js-cookie';
import DesktopLandingPage from './components/DesktopLandingPage.vue';

export default {
  components: {
    DesktopLandingPage,
  },
  data() {
    return {
      isMobile: true,
      deferredPrompt: null,
      showIOSBaner: false,
    };
  },
  created() {
    this.isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
    // if (!this.isMobile) window.location.href = 'https://fckpoor-beta.webflow.io/';
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
    });
  },
  mounted() {
    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      // Snackbar.open('Look at me!');
    }
  },
  methods: {
    ...mapActions({
      setLoginModalDisplay: 'userStore/setLoginModalDisplay',
    }),
    isIos() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    },
    download() {
      if (this.isIos()) {
        this.showIOSBaner = true;
      } else {
        this.install();
      }
    },
    async dismiss() {
      Cookies.set('add-to-home-screen', null, { expires: 15 });
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
  },
};
</script>

<style scoped lang='scss'>
.signin-wrapper {
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  background: $background-light-color;
  overflow-y: auto;
  padding-bottom: 40px;
}
.image-wrapper {
  margin: 0 auto;
}
.header {
  padding-top: 20px;
  font-size: 2.5rem;
  margin: 0 25px;
  text-align: left;
  color: $font-dark-color;
}
.login-button {
  font-weight: 600;
  font-size: 1.4rem;
  text-align: center;
  padding: 20px 25px;
  margin: 30px auto;
  border-radius: 15px;
  background: $background-brand-color;
  color: $font-light-color;
  width: 250px;
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}
h2 {
  margin: 20px 25px;
  font-size: 32px;
  line-height: 1.2;
  text-align: left;
}
.install-baner-wrapper {
  position: fixed;
  bottom: 40px;
  left: 0;
  width: 100vw;
  &__positioner {
    position: relative;
  }
  &__text {
    position: absolute;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    bottom: 0;
    left: 0;
    width: 100vw;
    color: black;
    background: rgb(238, 238, 238);
  }
  &__arrow-down {
    position: absolute;
    width: 0;
    height: 0;
    left: 0;
    right: 0;
    bottom: -30px;
    margin: auto;
    border-left: 30px solid transparent;
    border-right: 30px solid transparent;
    border-top: 30px solid rgb(238, 238, 238);
  }
}
</style>
